import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { ToastrService } from "../../../../../services/toastr.service";
import { formatDateFromDate, formatingDateOrTime } from "../../../../../common/vue-helpers/modifiers/value-modifier";
import { IBlobResponse } from "../../../../../resources-vue/vue-interfaces/i-hospice-client";
import {
    IEvvDetailsHomeHealth,
    IEvvTaskDetailsHHPayload
} from "../../../../../resources-vue/vue-interfaces/i-visit-evv-hh";
import { PatientService } from "../../../../../services/patient.service";
import { AssetsService } from "../../../../../services/assets-service";
import { DownloadService } from "../../../../../services/download.service";

import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";

export default defineComponent({
    components: {
        FormSection
    },
    props: {
        visitDetails: {
            type: Object
        },
        cancel: {
            type: Function
        },
        ok: {
            type: Function
        }
    },

    data(vm) {
        return {
            _toastrService: null,
            _patientService: null,
            _assetService: null,
            _downloadService: null,
            evvDetails: null as IEvvDetailsHomeHealth,
            isLoading: true as boolean,
            isEditing: false as boolean,
            isData: false as boolean,
            clinicianSignatureAsset: null,
            patientSignatureAsset: null,
            caretakerSignatureAsset: null,
            confirmationStatus: 0,
            formatDateFromDate,
            formatingDateOrTime
        };
    },

    async created() {
        this._toastrService = Container.instance.get(ToastrService);
        this._patientService = Container.instance.get(PatientService);
        this._assetService = Container.instance.get(AssetsService);
        this._downloadService = Container.instance.get(DownloadService);
        this.isLoading = true;
        Object.assign(this.visitDetails, {});
        await this.getEvvDetails();
    },

    methods: {
        async getEvvDetails() {
            try {
                const payload: IEvvTaskDetailsHHPayload = {
                    Application: this.visitDetails.Application,
                    AgencyId: this.visitDetails.AgencyId,
                    TaskId: this.visitDetails.Id,
                    PatientId: this.visitDetails.PatientId,
                    EpisodeId: this.visitDetails.EpisodeId
                };
                const resp = await this._patientService.getEvvTaskDetailsHH(payload);
                if (resp.IsSuccessful) {
                    this.evvDetails = resp.data;
                    if (this.evvDetails?.ClinicianVerifiedDateTime === "0001-01-01T00:00:00") {
                        this.evvDetails.ClinicianVerifiedDateTime = "";
                    }
                    if (this.evvDetails?.VerifiedVisitTimeInDate === "0001-01-01T00:00:00") {
                        this.evvDetails.VerifiedVisitTimeInDate = "";
                    }
                    this.patientSignatureAsset = await this.getAssets(this.evvDetails.PatientSignatureAssetId);
                    this.caretakerSignatureAsset = await this.getAssets(this.evvDetails.CaretakerSignatureAssetId);
                    this.clinicianSignatureAsset = await this.getAssets(this.evvDetails.ClinicianSignatureAssetId);
                    this.isData = true;
                } else {
                    this._toastrService.error({
                        title: ` Error`,
                        message: `Featching EVV details Failed, Please Contact Axxess if issue persists.`
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
            }
        },

        async getAssets(asset: string) {
            try {
                let assetResp;
                if (asset && asset !== "00000000-0000-0000-0000-000000000000") {
                    await this._assetService
                        .downloadPatientDocuments({
                            assetId: asset,
                            agencyId: this.evvDetails.AgencyId,
                            application: this.visitDetails.Application
                        })
                        .then((response: IBlobResponse) => {
                            assetResp = window.URL.createObjectURL(response.body as Blob);
                        });
                    return assetResp;
                }
            } catch (err) {
                this._toastrService.error({
                    title: ` Error`,
                    message: `Failed to fetch Signatur.`
                });
            }
        },

        formatHHEvvDate(date: any, isClinicianVerifiedDate: boolean = false) {
            if (date && date !== "0001-01-01T00:00:00") {
                return formatingDateOrTime(date, "MM/DD/YYYY hh:mm A") + " " + this.evvDetails.VerifiedVisitTimeZone;
            }
            return isClinicianVerifiedDate ? "-" : "Not Collected";
        },

        downloadAudio(asset: any) {
            this._assetService.getVisitDocumentBlobByUrl(asset.Url).then((response: IBlobResponse) => {
                this._downloadService.downloadFileWithFileName(response, "audio/aac", asset.DocumentName);
            });
        },

        closeDialog() {
            this.cancel();
        }
    }
});
